import Roles from '@/shared/utils/roles.js'
import ActionsForm from '@/shared/mixins/actionsForm'
import Tools from '@/components/tools/Tools'
import { loading } from '@/shared/utils/UIHelper'
import EmployeeRepository from '@/shared/http/repositories/configurations/employee'
import FormSearch from './search-form.js'
import AccountRepository from '@/shared/http/repositories/configurations/account.js'
import ProductRepository from '@/shared/http/repositories/configurations/product.js'
import { JWTService } from '@/shared/services/jwt'

import NxDatePicker from '@/components/forms/NxDatePicker.vue'

const DataSearch = {
  nome: null,
  document: null,
  gerenteId: null,
  responsavelId: null,
  usuarioId: null,
  produtosId: null,
  dataSituacaoInicial: null,
  dataSituacaoFinal: null
}

export default {
  name: 'CardSearch',
  mixins: [ActionsForm],
  components: {
    NxDatePicker
  },
  data () {
    return {
      data: DataSearch,
      form: FormSearch,
      roles: Roles,
      permissions: null,
      selected: 'gerente',
      employee: {
        listOptions: [],
        selected: null,
        selectedList: []
      },
      responsible: {
        listOptions: [],
        selected: null,
        selectedList: []
      },
      user: {
        listOptions: [],
        selected: null,
        selectedList: []
      },
      product: {
        listOptions: [],
        selected: null,
        selectedList: []
      }
    }
  },
  props: {
    parentComponent: {
      type: Object
    }
  },
  created () {
    this.onClear()
    this.permissions = JWTService.GetRoles()
    // this.onLoadEmployee()
    this.onLoadEmployeesFromUser()
    this.onLoadProducts()
  },
  methods: {
    onLoad () {
      this.onClearFilters()
    },
    onClearFilters () {
      this.employee.selected = null
      this.responsible.selected = null
      this.product.selected = null
      this.user.selected = null
      // this.interacao.selected = null
      Tools.SetFormDefaultValues(this.form)
      this.parentComponent.filters = null
      this.parentComponent.onLoadCard()
    },
    onFilter () {
      Tools.SetValueToSave(this.form, this.data)
      this.onGetSelectedValues()

      if (this.validateFilter()) {
        this.$eventHub.emit('Filter', { filters: this.data })
      } else {
        this.$eventHub.emit('Filter', { filters: null })
      }
    },
    validateFilter () {
      let result = false
      if (this.data) {
        this.data.document = this.data.document ? this.data.document.toString().replace(/[^\d]+/g, '') : null
        this.data.nome = this.data.nome ? encodeURIComponent(this.data.nome) : null

        if (
          this.data.nome ||
          this.data.document ||
          this.data.gerenteId ||
          this.data.responsavelId ||
          this.data.usuarioId ||
          this.data.produtosId ||
          this.data.dataSituacaoInicial ||
          this.data.dataSituacaoFinal) {
          result = true
        }
      }
      return result
    },
    onGetSelectedValues () {
      if (this.employee.selected && this.employee.selected.length > 0) {
        this.data.gerenteId = this.employee.selected.map(employee => employee.value)
      } else {
        this.data.gerenteId = null
      }

      if (this.responsible.selected && this.responsible.selected.length > 0) {
        this.data.responsavelId = this.responsible.selected.map(responsible => responsible.value)
      } else {
        this.data.responsavelId = null
      }

      if (this.user.selected && this.user.selected.length > 0) {
        this.data.usuarioId = this.user.selected.map(user => user.value)
      } else {
        this.data.usuarioId = null
      }

      if (this.product.selected && this.product.selected.length > 0) {
        this.data.produtosId = this.product.selected.map(product => product.value)
      } else {
        this.data.produtosId = null
      }
      // if (this.interacao.selected && this.interacao.selected.lenght > 0) {
      //   this.data.interacao = this.initeracao.selected.map(interacao => interacao.value)
      // } else {
      //   this.data.interacao = null
      // }
    },
    onLoadEmployee () {
      loading.push()
      EmployeeRepository.GetAll()
        .then((res) => {
          this.employee.listOptions = res.data.content.filter((x) => x.usuarioId != null).map((x) => ({'value': x.id, 'text': x.pessoa.nome}))
          this.responsible.listOptions = res.data.content.filter((x) => x.usuarioId != null).map((x) => ({'value': x.usuarioId, 'text': x.pessoa.nome}))
          this.user.listOptions = res.data.content.filter((x) => x.usuarioId != null).map((x) => ({'value': x.usuarioId, 'text': x.pessoa.nome}))
          loading.pop()
        })
        .catch(this.onException)
    },
    onLoadEmployeesFromUser () {
      loading.push()
      if (this.hasRole(this.roles.ADMINISTRADOR)) {
        this.onLoadEmployee()
      } else {
        AccountRepository.GetAllFromUser()
          .then((res) => {
            this.employee.listOptions = res.data.filter((x) => x.usuarioId != null).map((x) => ({'value': x.id, 'text': x.pessoa.nome}))
            this.responsible.listOptions = res.data.filter((x) => x.usuarioId != null).map((x) => ({'value': x.usuarioId, 'text': x.pessoa.nome}))
            this.user.listOptions = res.data.filter((x) => x.usuarioId != null).map((x) => ({'value': x.usuarioId, 'text': x.pessoa.nome}))
            loading.pop()
          })
          .catch(this.onException)
      }
    },
    onLoadProducts () {
      loading.push()
      ProductRepository.GetAll()
        .then((res) => {
          this.product.listOptions = res.data.content.map((x) => ({'value': x.id, 'text': x.nome}))
          loading.pop()
        })
        .catch(this.onException)
    }
  }
}



// WEBPACK FOOTER //
// ./src/views/private/crm/card/search/search.js